import type { CompanyDTO, CompanyTag } from "@shaarp/common";

/**
 * The tag the company page asks `POST /company/preview` with: its id and name,
 * so the server files the profile under `company:<id>` (`docs/decisions/0016`),
 * plus the town and identifiers the page already holds, so a profile a chat
 * chip of the same company built before it entered the base is served instead
 * of paying for a second run. Empty values are left out: the tag carries what
 * the page knows, nothing typed in its place.
 */
export function companyWebTagOf(company: CompanyDTO): CompanyTag {
  const city = company.location?.address?.city;
  const { siren, siret } = company.business ?? {};
  return {
    id: company.id,
    name: company.name,
    ...(city && { city }),
    ...(siren && { siren }),
    ...(siret && { siret }),
    ...(company.domain && { domain: company.domain }),
  };
}
